import TagIconPath from "@ingka/ssr-icon/paths/tag";

export default TagIconPath;
